export default __webpack_public_path__ + "static/media/1.ac45235f.jpg";